import { render, staticRenderFns } from "./Secretariat.vue?vue&type=template&id=d0e1e4ac&scoped=true&"
import script from "./Secretariat.vue?vue&type=script&lang=js&"
export * from "./Secretariat.vue?vue&type=script&lang=js&"
import style0 from "./Secretariat.vue?vue&type=style&index=0&id=d0e1e4ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e1e4ac",
  null
  
)

export default component.exports